import { SlateResponse } from "../common/store/types";
import { LateSwapPlayer } from "../lateSwap/store/types";
import { LineupApiResponse } from "../preContest/queries/queryTypes";

export const isInLineup = (exportableLineup: string, player: string, site: string, sport: string) => {
    if (player.includes("||")) {
        const playerInfo = player.split("||");
        const lineup = exportableLineup.split(",");
        return playerInfo[1] === "FLEX" 
            ? lineup.some((x, index) => index !== 0 && x.includes(playerInfo[0]))
            : lineup[0].includes(playerInfo[0]);
    }
    return exportableLineup.includes(player);
}

export const showdownPositions = ["CPT", "FLEX"];

export const getExposuresKey = (player: LineupApiResponse): string => {
    if (showdownPositions.includes(player.position?.toUpperCase())) {
        return `${player.player}${player.position?.toUpperCase()}`;
    }
    return player.player;
}
export const getExposuresKeyLateSwap = (player: LateSwapPlayer): string => {
    if (showdownPositions.includes(player.position?.toUpperCase())) {
        return `${player.name}${player.position?.toUpperCase()}`;
    }
    return player.name;
}

export const getExposuresKeyLineupPlayer = (player: string, index: number, slateType: string, sport: string, site: string): string => {
    if (slateType?.toUpperCase() === 'SHOWDOWN') {
        return index === 0 ? `${player}CPT` : `${player}FLEX`;
    }
    return player;
}

export const getSiteForShowdown = (site: string | undefined) => {
    if (site?.toUpperCase() === 'FD') {
        return 'FD_SINGLE';
    } else if (site?.toUpperCase() === 'DK') {
        return 'DK_SHOWDOWN';
    }
}

export const getCptOwnershipColumnName = (slate: SlateResponse, disableCustomization: boolean) => {
    if (slate.type?.toUpperCase() === "SHOWDOWN") {
        return !disableCustomization ? 'Projected CPT Ownership' : "CPT Ownership %";
    }
    else {
        return "CPT Ownership %";
    }
}

export const getOwnershipColumnName = (slate: SlateResponse, disableCustomization: boolean) => {
    if (slate.type === "Showdown") {
        return !disableCustomization ? 'Projected FLEX Ownership' : "FLEX Ownership %";
    }
    else {
        return "Ownership %";
    }
}